import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminMoments = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/moments/index/index.vue')
    createVueApp(IndexPage, { props })
  }
}
